var u = /* @__PURE__ */ ((n) => (n.In = "in", n.Has = "has", n.And = "and", n.NotIn = "notin", n.Null = "null", n.NotNull = "notnull", n.LT = "lt", n.LTE = "lte", n.GT = "gt", n.GTE = "gte", n))(u || {}), s = /* @__PURE__ */ ((n) => (n.Or = "or", n.And = "and", n))(s || {}), N = /* @__PURE__ */ ((n) => (n.Asc = "asc", n.Desc = "desc", n))(N || {});
export {
  s as APIFilterCondition,
  u as APIFilterOperator,
  N as APIOrderDirection
};
